import React from "react";
import PropTypes from "prop-types";
import { Spacer, Text } from "@badi/badi-components";
import InjectHtml from "components/inject-html";

const Reason = ({ answer, dataQa, question }) => {
  return (
    <>
      <Spacer bottom={2} top={3}>
        <Text body="14-Bold" dataQa={`${dataQa}-title`}>
          {question}
        </Text>
      </Spacer>
      <Text body="14-Regular" dataQa={`${dataQa}-desc`}>
        <InjectHtml>{answer}</InjectHtml>
      </Text>
    </>
  );
};

Reason.propTypes = {
  answer: PropTypes.string.isRequired,
  dataQa: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
};

export default Reason;
